import { CoreMenu } from 'src/@core/types';

export const attendanceMenu: CoreMenu[] = [
  {
    id: 'my-attendance',
    title: 'My Attendance',
    type: 'item',
    url: 'hr360/attendance/self',
    role: {
      roles: ['employee'],
      module: 'attendance',
      right: 'view',
    },
  },
  {
    id: 'team-attendance',
    title: 'Team Attendance',
    type: 'item',
    url: 'hr360/attendance/team',
    role: {
      roles: ['employee'],
      module: 'team-attendance',
      right: 'view',
    },
  },
];
